var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user",
    fill: "#DDDDDD",
    d: "M434.058,300.573v34.27c0,6.85-5.553,12.401-12.402,12.401H161.223 c-6.85,0-12.402-5.552-12.402-12.401v-34.27c0.353-7.366,4.817-13.908,11.548-16.923l63.695-33.547 c10.343,21.345,31.909,34.966,55.628,35.133h23.495c23.719-0.167,45.284-13.789,55.625-35.135l63.697,33.549 C429.24,286.664,433.705,293.206,434.058,300.573z M218.826,175.181c3.224,7.701,8.951,14.089,16.255,18.131l8.257,37.847 c3.729,17.09,18.858,29.274,36.35,29.274h23.503c17.492,0,32.621-12.185,36.35-29.273l8.258-37.847 c7.304-4.042,13.031-10.431,16.254-18.131l3.473-9.319c3.926-7.8,0.786-17.306-7.014-21.231c-0.283-0.143-0.571-0.277-0.863-0.402 v-32.614c0-37.205-24.803-62.008-68.208-62.008s-68.208,24.803-68.208,62.008v32.614c-8.022,3.449-11.729,12.748-8.28,20.771 c0.125,0.291,0.26,0.579,0.402,0.862L218.826,175.181z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b8869bb08709d3ecdfc5a4fddee9f69f.svg";
export { ForwardRef as ReactComponent };